import { Navbar } from "@/sections/Navbar/Navbar";
import { Hero } from "@/sections/Hero/Hero";
import { WhatIs } from "@/sections/WhatIs/WhatIs";
import { HowItWorks } from "@/sections/HowItWorks/HowItWorks";
import { ForProfessionals } from "@/sections/ForProfessionals/ForProfessionals";
import { Trust } from "@/sections/Trust/Trust";
import { ShowApp } from "@/sections/ShowApp/ShowApp";
import { FAQ } from "@/sections/FAQ/FAQ";
import { FinalCTA } from "@/sections/FinalCTA/FinalCTA";
import { Footer } from "@/sections/Footer/Footer";
import { ComingSoon } from "@/components/ComingSoon/ComingSoon";

// ─── Toggle de modo ──────────────────────────────────────────────────────────
// Cambiar a "coming-soon" antes de lanzar para mostrar el placeholder público.
// Cambiar a "full" cuando estemos listos para anunciar.
const MODE: "full" | "coming-soon" = "full";

export function Landing() {
  if (MODE === "coming-soon") {
    return <ComingSoon />;
  }

  return (
    <>
      <Navbar landing />
      <main>
        <Hero />
        <WhatIs />
        <HowItWorks />
        <ForProfessionals />
        <Trust />
        <ShowApp />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer landing />
    </>
  );
}
